import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any;

@Component({
	selector: 'app-foundation',
	templateUrl: './foundation.component.html',
	styleUrls: ['./foundation.component.scss']
})
export class FoundationComponent implements OnInit {

	eventrequest: any = {};
	foundationrequest: any = {};
	foundationList: any = "";
	foundationeventList: any = "";
	withfoundationList: any = "";
	evnetList: any = "";
	bannerrequest: any = {};
	bannerList: any = "";
	communityList: any = "";
	communitystaffList: any = {};
	communityRequest: any = {};
	slideeventConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slideourstaffConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 4,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	constructor(private allpagesService: AllPageService,) { }

	ngOnInit() {

		this.loadBanner();
		this.loadeventfirst();
		this.loadfoudationevent();
		this.loadcommunitystaff();
		this.allpagesService.getFoundation().then((data) => {
			this.withfoundationList = data.data[0];
			//console.warn(this.withfoundationList);
			this.foundationList = data;

		});
		
	}

	loadBanner() {
		this.bannerrequest = {
			title: 'Foundation'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.bannerList = data.data[0];
			//console.log(this.bannerList);
		});
	}

	loadeventfirst() {
		this.eventrequest = {
			slug: 'grace-road'
		}
		let request = Object.assign({}, this.eventrequest);
		this.allpagesService.getEventtype(request).then((data: any) => {
			this.evnetList = data;
			//console.warn(this.evnetList);
		});
	}
	loadcommunitystaff() {
		this.allpagesService.getCommunityTrustee().then((data: any) => {
			this.communitystaffList = data.data;
			setTimeout(() => {
			
				jQuery('.popup-login1').magnificPopup({
					type: 'inline',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,
		  
					fixedContentPos: false,
					callbacks: {
					  open: function() {
						jQuery("body").addClass("overflow");
					  },
					  close: function() {
						jQuery("body").removeClass("overflow");
					  }
					  // e.t.c.
					}
				  });
				
			}, 1000);
		});
	}
	loadfoudationevent() {
		this.foundationrequest = { };
		let request = Object.assign({}, this.foundationrequest);
		this.allpagesService.getFoundationevent(request).then((data: any) => {
			this.foundationeventList = data;
			console.log(this.foundationeventList);

			
		});
	}


}
